import React, {Component} from 'react';
import {Link} from 'react-router';
import formatNumbers  from 'util/formatNumbers';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import moment from 'moment';
import { calculateTransactionPayoutAmount} from 'dashboard/transactions/transactionsPageMethods';

import config from  '../../../config';
import {
    linkFormatter,
    customFormatter,
    prepareSelectOptionsList,
    actionsFormatter,
    priceFormatter,
    getFieldByPathFormatter
} from 'util/Utils';
import {displayCustomDialog}  from 'util/Utils';

import {ADD_SELECTED_TRANSACTIONS,
    REMOVE_SELECTED_TRANSACTIONS
} from "actions/actionTypes";


import CustomTableHeaderCheckbox from 'shared/table/CustomTableHeaderCheckbox';


class PartnerTransactionListTable extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.editTransaction = this.editTransaction.bind(this);
        this.updateTransaction = this.updateTransaction.bind(this);


        this.state = {
            perPage: config.table.numberPerPage,
            currentRecord: {},
        };
     }

    customActionsFormatter(cell, row, extra) {
        var menuItemsMap = [];


        return actionsFormatter.call(this, cell, row, {menuItemsMap})
    }

    componentWillReceiveProps(nextProps) {

        if (_.size(nextProps.allSellersList.data) !== _.size(this.props.allSellersList.data)) {
            this.allSellersOptionsList = prepareSelectOptionsList(nextProps.allSellersList.data, {
                label: 'DisplayName',
                value: '_id'
            })

        }
    }

    editTransaction(row) {
        this.context.router.push(`/admin/transaction/${encodeURIComponent(row._id)}/edit`)
    }

    updateTransaction(data) {
        console.log('in update transaction', data);
        var objectData = {};
        // if (!_.isUndefined(data.event)) { /* for checkboxes*/
        //     //console.log('event', event.target.getAttribute('value'));
        //     if (data.cellName == 'Status') {
        //         objectData[data.cellName] = data.event.target.checked ? 'Active' : 'Inactive';
        //     }
        // } else {
        objectData[data.cellName] = data.row[data.cellName];
        // }
        var methodData = {
            success_event: UPDATE_ADMIN_TRANSACTION,
            type: 'patch',
            endpoint: '/transactions/' + encodeURIComponent(data.row._id),
            messageData: {'#1#': 'Transaction'},
            messageCode: 'recordUpdated'
        }
        this.props.makeRequest(objectData, methodData).then(function (response) {
            // this.context.router.goBack();
        }.bind(this));
    }

    hideModal() {
        this.setState({currentRecord: {}});
    }



    customLinkFormatter(cell, row) {
        return (
            <Link className=""
                  to={`/admin/transaction/${encodeURIComponent(row._id)}/edit`}>{`${row.TransactionName}`}</Link>
        );
    }

    stringToCheckboxFormatter(cell, row, extra) {
        return (
            <input type="checkbox" onChange={(event) => this.updateTransaction({row, cellName: extra, event})}
                   defaultChecked={row[extra] == 'Active' ? true : false}>
            </input>
        );
    }

    // stringToSelectboxFormatter(cell, row, extra) {
    //     return (
    //         <Select
    //             tabIndex="0"
    //             placeholder="Seller"
    //             clearable={false}
    //             options={this.allSellersOptionsList}
    //             onChange={(value)=>{this.onSellerChange(row,value)}}
    //             //  filterOptions={filterOptions}
    //             value={row['SellerID'][0]._id}
    //         />
    //     );
    // }

    stringToCheckboxFormatter2(cell, row, extra) {
        return (
            <input type="checkbox" onChange={(event) => this.updateTransaction({row, cellName: extra, event})}
                   defaultChecked={row[extra]}>
            </input>
        );
    }


    ShopifyTransactionLinkFormatter(cell, row, extra) {
        if (row.Status == 'Active') {
            if (_.get(row, extra.path, false)) {
                return linkFormatter(cell, row, extra)
            } else {
                return <div>{_.get(row, extra.labelPath, extra.label ? extra.label : 'Link')} </div>
            }

        } else {

            return <div>{ _.get(row, 'TransactionName')}</div>
        }
    }


    onRowSelect(row, isSelected, e) {
        var actionName = isSelected ? ADD_SELECTED_TRANSACTIONS : REMOVE_SELECTED_TRANSACTIONS;
        this.props.dispatchAction([row], actionName)
    }

    onAllRowSelect(isSelected, rows) {
        console.log('isSelected', rows);
        var actionName = isSelected ? ADD_SELECTED_TRANSACTIONS : REMOVE_SELECTED_TRANSACTIONS;
        this.props.dispatchAction(rows, actionName)
    }

    customMultiSelect(props) {
        if (!_.isUndefined(this.refs.table)) {
            var rowIDs = _.map(this.refs.table.state.data, function (row, key) {
                return row._id;
            });
        }
        var {type, checked, disabled, onChange, rowIndex} = props;

        if (!_.isUndefined(rowIDs) && rowIndex !== 'Header') {
            checked = _.includes(this.props.adminTransactions.selectedTransactions, rowIDs[rowIndex])
        }

        /*
         * If rowIndex is 'Header', means this rendering is for header selection column.
         */
        if (rowIndex === 'Header') {

            return (
                <div className='checkbox-personalized'>
                    <CustomTableHeaderCheckbox { ...props }/>
                    <label htmlFor={ 'checkbox' + rowIndex }>
                        <div className='check'></div>
                    </label>
                </div>);
        } else {
            return (
                <div className='checkbox-personalized'>
                    <input
                        type={ type }
                        name={ 'checkbox' + rowIndex }
                        id={ 'checkbox' + rowIndex }
                        checked={ checked }
                        disabled={ disabled }
                        onChange={ e => onChange(e, rowIndex) }
                    />
                    <label htmlFor={ 'checkbox' + rowIndex }>
                        <div className='check'></div>
                    </label>
                </div>);
        }
    }
    calculatePayoutFormatter(cell, row) {
        if (row.Type == 'Sale') {
            if (_.isUndefined(row.SaleData.PayoutPercentage)) {
                console.log('Product payout is not available', row);
                return this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Product payout is not available in transaction record'
                });
            }

            const payoutAmount = calculateTransactionPayoutAmount(row, this.props.appData.FeatureFlags);
             return `+${formatNumbers.formatMoney(payoutAmount)}`;
           } else if (row.Type == 'Credit') {
            return '+' + formatNumbers.formatMoney(row.Amount);
        } else if (row.Type == 'Fee' || row.Type == 'PickupFee') {
            return '-' + formatNumbers.formatMoney(row.Amount);
        } else if (row.Type == 'Fee' || row.Type == 'WorkingTime') {
            return '-' + formatNumbers.formatMoney(row.Amount);
        }
    }
    render() {
        console.log('this.state', this.state);
        var self = this;
        //console.log('this props', this.props);
        const selectRowProp = {
            mode: 'checkbox',
            columnWidth: '29px',
            onSelect: this.onRowSelect.bind(this),
            onSelectAll: this.onAllRowSelect.bind(this),
            customComponent: this.customMultiSelect.bind(this)

        }

        return (
            <div className="  databases-table">
                <BootstrapTable data={this.props.adminTransactions.data} ref='table'
                             selectRow={ selectRowProp }
                                remote={ true }
                                hover={true}
                                condensed={true}
                                striped={true}
                                options={ {
                                    ...config.bootstrapTableOptions,
                                    onSortChange: this.props.onSortChange
                                } }
                >
                    <TableHeaderColumn width="70px" dataField="SellerID.DisplayName" dataAlign="center"
                                       dataFormat={ getFieldByPathFormatter }    formatExtraData={ {path: ['SellerID', 'DisplayName']}} dataSort={true}>Seller</TableHeaderColumn>

                    <TableHeaderColumn width="80" dataField="ProductID.ProductName" dataAlign="center"
                                       formatExtraData={ {path: ['ProductID', 'ProductName']}}
                                       dataFormat={ getFieldByPathFormatter } dataSort={true}>Product
                        Title</TableHeaderColumn>
                    <TableHeaderColumn width="60px" dataAlign="center"
                                       dataField="Description" dataSort={true}>Description</TableHeaderColumn>
                    <TableHeaderColumn dataField="_id" isKey={true} hidden={true}
                                       autoValue={ true } hiddenOnInsert>Id</TableHeaderColumn>

                    <TableHeaderColumn width="40px" dataField="FulfilledAt" dataAlign="center"
                                       dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['FulfilledAt'],
                                           format: (value) => {
                                               if (value) {
                                                   return <div>
                                                       <div>{  moment(value).format('MM/DD')}</div>
                                                       <div>{  moment(value).format('YYYY')}</div>
                                                   </div>
                                               } else {
                                                   return ''
                                               }
                                           }
                                       }}
                                       dataSort={true}>Fulfilled At</TableHeaderColumn>
                    <TableHeaderColumn width="40px" dataField="PaidAt" dataAlign="center"
                                       dataFormat={ customFormatter }
                                       formatExtraData={ {
                                           path: ['PaidAt'],
                                           format: (value) => {
                                               if (value) {
                                                   return <div>
                                                       <div>{  moment(value).format('MM/DD')}</div>
                                                       <div>{  moment(value).format('YYYY')}</div>
                                                   </div>
                                               } else {
                                                   return ''
                                               }
                                           }
                                       }}
                                       dataSort={true}>Paid At</TableHeaderColumn>
                    <TableHeaderColumn width="25" dataField="SaleData.PayoutPercentage" dataAlign="center"

                                       dataFormat={ customFormatter } formatExtraData={ {
                        path:  ['SaleData', 'PayoutPercentage'], format: (value) => {
                            return value ? value + '%':''
                        }
                    }} dataSort={true}>Payout %</TableHeaderColumn>
                    <TableHeaderColumn width="40px" columnClassName={ 'blue' } dataAlign="center"
                                       dataFormat={ this.calculatePayoutFormatter.bind(this) }
                    >Payout</TableHeaderColumn>

                    <TableHeaderColumn width="40px" dataFormat={ priceFormatter }
                                       dataFormat={ customFormatter } formatExtraData={ {
                        path: ['getObject'], format: (item) => {
                            const {SIIPEnabled} =  this.props.appData.FeatureFlags;
                            const {ProductBasePriceWithDiscount = -1} = item.SaleData || {};
                            let amount = item.Amount;

                            if(SIIPEnabled && ProductBasePriceWithDiscount > -1) {
                                amount = ProductBasePriceWithDiscount;
                            }

                            return formatNumbers.formatMoney(amount);
                        }}}
                         dataAlign="center"
                         dataSort={true}>Amount Sold</TableHeaderColumn>
                    <TableHeaderColumn width="45px" dataField='Status' dataAlign="center"
                                       dataFormat={ customFormatter } formatExtraData={ {
                        path: ['Status'], format: (value) => {
                            return _.startCase(value)
                        }
                    }}
                                       dataSort={true}>Status</TableHeaderColumn>
                    <TableHeaderColumn width="50px"  dataAlign="center" dataField='MarketName'
                                       dataSort={true}>Location</TableHeaderColumn>


                    <TableHeaderColumn width="30px" dataAlign="center" dataFormat={  this.typeFormatter }
                                       dataField="Type" dataSort={true}>Type</TableHeaderColumn>

                </BootstrapTable>
                {displayCustomDialog.call(this, {
                    cancelButtonTitle: 'Close',
                    buttonTitle: 'doNotDisplay',
                    dialogContent: () => {
                        return <div>

                            { self.state.currentRecord.UserImageURL &&

                            <div style={{width: 200, margin: '0 auto'}}>
                                <img style={{margin: '0 auto', maxWidth: 200, maxHeight: 200}}
                                     src={self.state.currentRecord.UserImageURL}/>
                            </div>

                            }
                            { self.state.currentRecord.UserNotes &&
                            <div  ><span className="text-bold">User notes:</span> {self.state.currentRecord.UserNotes}
                            </div>
                            }
                        </div>
                    },
                    cancelActionHandler: () => {
                    },
                    confirmActionHandler: (data) => {
                    },
                    modalTitle: 'Details',
                    dialogID: 'TransactionNumberDetails'
                })}
            </div>
        );
    }
}


export default PartnerTransactionListTable;
